export const SellingProduct =[
   {
      title:"Nike Shoes",
      items:"451 item",
      percentage:"-05%",
      price:"$49.00",
      img:"1.png"
   },
   {
      title:"Headphone",
      items:"1657 item",
      percentage:"-20%",
      price:"$28.00",
      img:"2.png"

   },
   {
      title:"Tree Pot",
      items:"32 item",
      percentage:"-12%",
      price:"$30.00",
      img:"3.png"

   },
   {
      title:"Black Purse",
      items:"663 item",
      percentage:"-16%",
      price:"$22.00",
      img:"4.png"
   },
   {
      title:"Ck Watch",
      items:"4785 item",
      percentage:"-50%",
      price:"$48.00",
      img:"5.png"

   },
   {
      title:"New T-shirt",
      items:"9 item",
      percentage:"-20%",
      price:"$69.00",
      img:"6.png"


   },
   {
      title:"Jewellery",
      items:"7878 item",
      percentage:"-10%",
      price:"$78.00",
      img:"7.png"

   },
   {
      title:"Smart Phone",
      items:"987 item",
      percentage:"-30%",
      price:"$36.00",
      img:"8.png"


   }
]